import { __assign, __rest, __awaiter, __generator } from 'tslib';
import classnames from 'classnames';
import React, { useRef, useMemo, useEffect } from 'react';
import { useSafeState, useLatest } from 'rc-hooks';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "@-webkit-keyframes slider-icon-animate_spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes slider-icon-animate_spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.rc-slider-captcha-icon {\n  display: inline-block;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.rc-slider-captcha-icon > svg {\n  line-height: 1;\n}\n.rc-slider-captcha-icon-spin {\n  -webkit-animation: slider-icon-animate_spin 1s infinite linear;\n          animation: slider-icon-animate_spin 1s infinite linear;\n}\n.rc-slider-captcha-button {\n  display: inline-block;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  width: 40px;\n  height: 100%;\n  padding: 5px 0;\n  color: #676d73;\n  font-size: 22px;\n  line-height: 1;\n  background-color: #fff;\n  border-radius: 2px;\n  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);\n  cursor: -webkit-grab;\n  cursor: grab;\n  transition-timing-function: linear;\n  transition-duration: 0.2s;\n  transition-property: background-color, color;\n  touch-action: none;\n}\n.rc-slider-captcha-button-active {\n  color: #fff;\n  background-color: #1991fa;\n  background-color: var(--rcsc-primary, #1991fa);\n}\n.rc-slider-captcha-button-verify {\n  color: #fff;\n  background-color: #1991fa;\n  background-color: var(--rcsc-primary, #1991fa);\n}\n.rc-slider-captcha-button-pc:hover {\n  color: #fff;\n  background-color: #1991fa;\n  background-color: var(--rcsc-primary, #1991fa);\n}\n.rc-slider-captcha-button:active {\n  color: #fff;\n  background-color: #1991fa;\n  background-color: var(--rcsc-primary, #1991fa);\n}\n.rc-slider-captcha-button-active,\n.rc-slider-captcha-button:active {\n  cursor: -webkit-grabbing;\n  cursor: grabbing;\n}\n.rc-slider-captcha-button-verify,\n.rc-slider-captcha-button-verify:active {\n  cursor: wait;\n}\n.rc-slider-captcha-button-error {\n  color: #fff;\n  background-color: #f57a7a;\n  background-color: var(--rcsc-error, #f57a7a);\n  cursor: default;\n}\n.rc-slider-captcha-button-error:hover {\n  color: #fff;\n  background-color: #f57a7a;\n  background-color: var(--rcsc-error, #f57a7a);\n  cursor: default;\n}\n.rc-slider-captcha-button-error:active {\n  color: #fff;\n  background-color: #f57a7a;\n  background-color: var(--rcsc-error, #f57a7a);\n  cursor: default;\n}\n.rc-slider-captcha-button-success {\n  color: #fff;\n  background-color: #52ccba;\n  background-color: var(--rcsc-success, #52ccba);\n  cursor: default;\n}\n.rc-slider-captcha-button-success:hover {\n  color: #fff;\n  background-color: #52ccba;\n  background-color: var(--rcsc-success, #52ccba);\n  cursor: default;\n}\n.rc-slider-captcha-button-success:active {\n  color: #fff;\n  background-color: #52ccba;\n  background-color: var(--rcsc-success, #52ccba);\n  cursor: default;\n}\n.rc-slider-captcha-button-disabled,\n.rc-slider-captcha-button-disabled:hover,\n.rc-slider-captcha-button-disabled:active {\n  color: #676d73;\n  background-color: #fff;\n  cursor: no-drop;\n}\n.rc-slider-captcha-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  padding: 15px;\n  color: #45494c;\n  color: var(--rcsc-text-color, #45494c);\n  font-size: 14px;\n  text-align: center;\n  background-color: #f7f9fa;\n  background-color: var(--rcsc-bg-color, #f7f9fa);\n}\n.rc-slider-captcha-loading-icon {\n  font-size: 30px;\n}\n.rc-slider-captcha-loading-text {\n  margin-top: 5px;\n}\n.rc-slider-captcha {\n  position: relative;\n}\n.rc-slider-captcha > * {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.rc-slider-captcha-control {\n  position: relative;\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 42px;\n  background-color: #f7f9fa;\n  background-color: var(--rcsc-bg-color, #f7f9fa);\n  border: 1px solid #e4e7eb;\n  border: 1px solid var(--rcsc-border-color, #e4e7eb);\n  border-radius: 2px;\n}\n.rc-slider-captcha-control-button {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n}\n.rc-slider-captcha-control-indicator {\n  position: absolute;\n  top: -1px;\n  bottom: -1px;\n  left: -1px;\n  display: none;\n  box-sizing: border-box;\n  width: 0;\n  background-color: #d1e9fe;\n  background-color: var(--rcsc-primary-light, #d1e9fe);\n  border: 1px solid #1991fa;\n  border: 1px solid var(--rcsc-primary, #1991fa);\n  border-radius: 2px;\n}\n.rc-slider-captcha-control-tips {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 0;\n  color: #45494c;\n  color: var(--rcsc-text-color, #45494c);\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  -webkit-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.rc-slider-captcha-control-moving .rc-slider-captcha-control-indicator,\n.rc-slider-captcha-control-verify .rc-slider-captcha-control-indicator,\n.rc-slider-captcha-control-error .rc-slider-captcha-control-indicator,\n.rc-slider-captcha-control-success .rc-slider-captcha-control-indicator {\n  display: block;\n}\n.rc-slider-captcha-control-error .rc-slider-captcha-control-indicator {\n  background-color: #fce1e1;\n  background-color: var(--rcsc-error-light, #fce1e1);\n  border-color: #f57a7a;\n  border-color: var(--rcsc-error, #f57a7a);\n}\n.rc-slider-captcha-control-success .rc-slider-captcha-control-indicator {\n  background-color: #d2f4ef;\n  background-color: var(--rcsc-success-light, #d2f4ef);\n  border-color: #52ccba;\n  border-color: var(--rcsc-success, #52ccba);\n}\n.rc-slider-captcha-control-errors {\n  padding-left: 0;\n  background-color: #fce1e1;\n  background-color: var(--rcsc-error-light, #fce1e1);\n  border-color: #f57a7a;\n  border-color: var(--rcsc-error, #f57a7a);\n}\n.rc-slider-captcha-control-errors .rc-slider-captcha-control-button,\n.rc-slider-captcha-control-errors .rc-slider-captcha-control-indicator {\n  display: none;\n}\n.rc-slider-captcha-control-errors .rc-slider-captcha-control-tips {\n  color: #f57a7a;\n  color: var(--rcsc-error, #f57a7a);\n  cursor: pointer;\n}\n.rc-slider-captcha-jigsaw {\n  position: relative;\n  background-color: #f7f9fa;\n  -webkit-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.rc-slider-captcha-jigsaw img {\n  position: absolute;\n}\n.rc-slider-captcha-jigsaw-bg {\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n.rc-slider-captcha-jigsaw-puzzle {\n  width: 60px;\n  height: 100%;\n  touch-action: none;\n}\n.rc-slider-captcha-jigsaw-puzzle:hover {\n  cursor: -webkit-grab;\n  cursor: grab;\n}\n.rc-slider-captcha-jigsaw-puzzle:active {\n  cursor: -webkit-grabbing;\n  cursor: grabbing;\n}\n.rc-slider-captcha-jigsaw-refresh {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 5px;\n  color: #fff;\n  font-size: 22px;\n  line-height: 0;\n  cursor: pointer;\n  opacity: 0.75;\n  transition: opacity 0.2s linear;\n}\n.rc-slider-captcha-jigsaw-refresh:hover {\n  opacity: 1;\n}\n.rc-slider-captcha-jigsaw-refresh-disabled {\n  cursor: not-allowed;\n}\n.rc-slider-captcha-jigsaw-refresh-disabled:hover {\n  opacity: 0.75;\n}\n.rc-slider-captcha-jigsaw-stop .rc-slider-captcha-jigsaw-puzzle {\n  pointer-events: none;\n}\n.rc-slider-captcha-jigsaw-stop .rc-slider-captcha-jigsaw-puzzle:hover,\n.rc-slider-captcha-jigsaw-stop .rc-slider-captcha-jigsaw-puzzle:active {\n  cursor: default;\n}\n.rc-slider-captcha-panel {\n  padding-bottom: 15px;\n}\n.rc-slider-captcha-panel-inner {\n  overflow: hidden;\n  border-radius: 2px;\n}\n.rc-slider-captcha-float .rc-slider-captcha-panel {\n  position: absolute;\n  left: 0;\n  display: none;\n  opacity: 0;\n  transition-timing-function: ease-out;\n  transition-duration: 0.3s;\n  transition-property: top, bottom, opacity;\n}\n.rc-slider-captcha-float-top .rc-slider-captcha-panel {\n  bottom: 22px;\n}\n.rc-slider-captcha-float-bottom .rc-slider-captcha-panel {\n  top: 22px;\n  padding: 15px 0 0;\n}\n";
styleInject(css_248z);

var IconArrowRight = function (props) {
    return (React.createElement("svg", __assign({ viewBox: "0 0 1024 1024", version: "1.1", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "currentColor" }, props),
        React.createElement("path", { d: "M116.9408 561.4592m0-40.96l0 0q0-40.96 40.96-40.96l573.44 0q40.96 0 40.96 40.96l0 0q0 40.96-40.96 40.96l-573.44 0q-40.96 0-40.96-40.96Z" }),
        React.createElement("path", { d: "M769.82272 519.43424l-203.22304-203.22304a40.96 40.96 0 1 1 57.91744-57.91744l231.71072 231.71072a40.96 40.96 0 0 1 0.45056 58.44992L624.9472 780.12416a40.96 40.96 0 0 1-57.93792-57.91744l202.79296-202.79296z" })));
};

var IconCheck = function (props) {
    return (React.createElement("svg", __assign({ viewBox: "0 0 1024 1024", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "currentColor" }, props),
        React.createElement("path", { d: "M864.554667 268.501333a42.666667 42.666667 0 0 1 0 60.330667L412.032 781.397333a42.453333 42.453333 0 0 1-22.613333 11.818667l-5.034667 0.597333H379.306667a42.496 42.496 0 0 1-27.648-12.416l-211.2-211.2a42.666667 42.666667 0 1 1 60.330666-60.330666l180.992 180.992 422.4-422.4a42.666667 42.666667 0 0 1 60.330667 0z" })));
};

var IconLoading = function (props) {
    return (React.createElement("svg", __assign({ viewBox: "0 0 120 120", width: "1em", height: "1em" }, props),
        React.createElement("defs", null,
            React.createElement("line", { id: "l", x1: "60", x2: "60", y1: "7", y2: "27", stroke: "currentColor", strokeWidth: "11", strokeLinecap: "round" })),
        React.createElement("g", null,
            React.createElement("use", { xlinkHref: "#l", opacity: ".27" }),
            React.createElement("use", { xlinkHref: "#l", opacity: ".27", transform: "rotate(30 60,60)" }),
            React.createElement("use", { xlinkHref: "#l", opacity: ".27", transform: "rotate(60 60,60)" }),
            React.createElement("use", { xlinkHref: "#l", opacity: ".27", transform: "rotate(90 60,60)" }),
            React.createElement("use", { xlinkHref: "#l", opacity: ".27", transform: "rotate(120 60,60)" }),
            React.createElement("use", { xlinkHref: "#l", opacity: ".27", transform: "rotate(150 60,60)" }),
            React.createElement("use", { xlinkHref: "#l", opacity: ".37", transform: "rotate(180 60,60)" }),
            React.createElement("use", { xlinkHref: "#l", opacity: ".46", transform: "rotate(210 60,60)" }),
            React.createElement("use", { xlinkHref: "#l", opacity: ".56", transform: "rotate(240 60,60)" }),
            React.createElement("use", { xlinkHref: "#l", opacity: ".66", transform: "rotate(270 60,60)" }),
            React.createElement("use", { xlinkHref: "#l", opacity: ".75", transform: "rotate(300 60,60)" }),
            React.createElement("use", { xlinkHref: "#l", opacity: ".85", transform: "rotate(330 60,60)" }))));
};

var IconRefresh = function (props) {
    return (React.createElement("svg", __assign({ viewBox: "0 0 1024 1024", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "currentColor" }, props),
        React.createElement("path", { d: "M866.133333 573.013333a42.666667 42.666667 0 0 0-53.333333 27.733334A304.64 304.64 0 0 1 519.68 810.666667 302.933333 302.933333 0 0 1 213.333333 512a302.933333 302.933333 0 0 1 306.346667-298.666667 309.76 309.76 0 0 1 198.4 71.253334l-92.586667-15.36a42.666667 42.666667 0 0 0-49.066666 35.413333 42.666667 42.666667 0 0 0 35.413333 49.066667l180.906667 29.866666h7.253333a42.666667 42.666667 0 0 0 14.506667-2.56 14.08 14.08 0 0 0 4.266666-2.56 33.28 33.28 0 0 0 8.533334-4.693333l3.84-4.693333c0-2.133333 3.84-3.84 5.546666-6.4s0-4.266667 2.133334-5.973334a57.173333 57.173333 0 0 0 2.986666-7.68l32-170.666666a42.666667 42.666667 0 0 0-85.333333-16.213334l-11.52 61.866667A392.96 392.96 0 0 0 519.68 128 388.266667 388.266667 0 0 0 128 512a388.266667 388.266667 0 0 0 391.68 384A389.12 389.12 0 0 0 896 626.346667a42.666667 42.666667 0 0 0-29.866667-53.333334z" })));
};

var IconX = function (props) {
    return (React.createElement("svg", __assign({ viewBox: "0 0 1024 1024", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "currentColor" }, props),
        React.createElement("path", { d: "M572.96896 524.6976l217.23136 217.25184a40.96 40.96 0 1 1-57.93792 57.91744L515.072 582.63552l-212.3776 212.3776a40.96 40.96 0 1 1-57.9584-57.91744l212.39808-212.3776-217.21088-217.23136a40.96 40.96 0 1 1 57.91744-57.91744l217.23136 217.21088L737.0752 244.736a40.96 40.96 0 1 1 57.93792 57.91744L572.96896 524.71808z" })));
};

var _a;
// className 前缀
var prefixCls = 'rc-slider-captcha';
// 获取事件触发客户端坐标
function getClient(e) {
    var x = 0, y = 0;
    if (typeof e.clientX === 'number' && typeof e.clientY === 'number') {
        x = e.clientX;
        y = e.clientY;
    }
    else if (e.touches && e.touches[0]) {
        x = e.touches[0].clientX;
        y = e.touches[0].clientY;
    }
    else if (e.changedTouches && e.changedTouches[0]) {
        x = e.changedTouches[0].clientX;
        y = e.changedTouches[0].clientY;
    }
    return {
        clientX: x,
        clientY: y
    };
}
// 设置样式
function setStyle(el, styleObj) {
    if (styleObj === void 0) { styleObj = {}; }
    if (el) {
        for (var prop in styleObj) {
            el.style[prop] = styleObj[prop];
        }
    }
}
// 当前运行环境是否可以使用 dom
var isBrowser = typeof window !== 'undefined' &&
    typeof document !== 'undefined' &&
    (window === null || window === void 0 ? void 0 : window.document) &&
    ((_a = window.document) === null || _a === void 0 ? void 0 : _a.addEventListener);
// 是否支持Touch事件
// 区分移动端和PC端的事件绑定，移动端也会触发 mouseup mousedown 事件
var isSupportTouch = typeof window === 'object' && 'ontouchstart' in window;
// 触发重绘
var reflow = function (node) { return node === null || node === void 0 ? void 0 : node.scrollTop; };

var currentPrefixCls$2 = "".concat(prefixCls, "-icon");
var SliderIconBase = function (_a) {
    var _b;
    var className = _a.className, spin = _a.spin, restProps = __rest(_a, ["className", "spin"]);
    return (React.createElement("span", __assign({ className: classnames(currentPrefixCls$2, (_b = {}, _b["".concat(currentPrefixCls$2, "-spin")] = spin, _b), className) }, restProps)));
};

var iconMap = {
    arrowRight: React.createElement(IconArrowRight, null),
    check: React.createElement(IconCheck, null),
    loading: React.createElement(IconLoading, null),
    refresh: React.createElement(IconRefresh, null),
    x: React.createElement(IconX, null)
};
var SliderIcon = function (_a) {
    var type = _a.type, restProps = __rest(_a, ["type"]);
    return React.createElement(SliderIconBase, __assign({}, restProps), iconMap[type]);
};

var currentPrefixCls$1 = "".concat(prefixCls, "-loading");
var LoadingBox = function (_a) {
    var _b = _a.icon, icon = _b === void 0 ? React.createElement(SliderIcon, { type: "loading", spin: true }) : _b, _c = _a.text, text = _c === void 0 ? '加载中...' : _c, className = _a.className, restProps = __rest(_a, ["icon", "text", "className"]);
    return (React.createElement("div", __assign({ className: classnames(currentPrefixCls$1, className) }, restProps),
        React.createElement("div", { className: "".concat(currentPrefixCls$1, "-icon") }, icon),
        React.createElement("div", { className: "".concat(currentPrefixCls$1, "-text") }, text)));
};

var currentPrefixCls = "".concat(prefixCls, "-button");
var SliderButton = React.forwardRef(function (_a, ref) {
    var _b;
    var className = _a.className, disabled = _a.disabled, active = _a.active, success = _a.success, error = _a.error, verify = _a.verify, mobile = _a.mobile, restProps = __rest(_a, ["className", "disabled", "active", "success", "error", "verify", "mobile"]);
    return (React.createElement("span", __assign({ className: classnames(currentPrefixCls, className, (_b = {},
            _b["".concat(currentPrefixCls, "-disabled")] = disabled,
            _b["".concat(currentPrefixCls, "-active")] = active,
            _b["".concat(currentPrefixCls, "-verify")] = verify,
            _b["".concat(currentPrefixCls, "-success")] = success,
            _b["".concat(currentPrefixCls, "-error")] = error,
            _b["".concat(currentPrefixCls, "-pc")] = !mobile,
            _b)), ref: ref }, restProps)));
});
SliderButton.displayName = 'SliderButton';

var CurrentTargetType;
(function (CurrentTargetType) {
    CurrentTargetType["Puzzle"] = "puzzle";
    CurrentTargetType["Button"] = "button";
})(CurrentTargetType || (CurrentTargetType = {}));
// 内部状态
var Status;
(function (Status) {
    Status[Status["Default"] = 1] = "Default";
    Status[Status["Loading"] = 2] = "Loading";
    Status[Status["Moving"] = 3] = "Moving";
    Status[Status["Verify"] = 4] = "Verify";
    Status[Status["Success"] = 5] = "Success";
    Status[Status["Error"] = 6] = "Error";
})(Status || (Status = {}));
var controlPrefixCls = "".concat(prefixCls, "-control");
var jigsawPrefixCls = "".concat(prefixCls, "-jigsaw");
var SliderButtonWidth = 40; // 滑块按钮宽度
var SliderBorderWidth = 2; // 滑块边框宽度
// 默认配置
var defaultConfig = {
    bgSize: {
        width: 320,
        height: 160
    },
    puzzleSize: {
        width: 60,
        left: 0
    },
    tipText: {
        default: '向右拖动滑块填充拼图',
        loading: '加载中...',
        moving: null,
        verifying: null,
        success: null,
        error: null,
        errors: (React.createElement(React.Fragment, null,
            React.createElement(SliderIcon, { type: "x", style: { fontSize: 20 } }),
            " \u5931\u8D25\u8FC7\u591A\uFF0C\u70B9\u51FB\u91CD\u8BD5"))
    },
    tipIcon: {
        default: React.createElement(SliderIcon, { type: "arrowRight" }),
        loading: React.createElement(SliderIcon, { type: "loading", spin: true }),
        error: React.createElement(SliderIcon, { type: "x" }),
        success: React.createElement(SliderIcon, { type: "check" }),
        refresh: React.createElement(SliderIcon, { type: "refresh" })
    }
};
var events = isSupportTouch
    ? {
        start: 'touchstart',
        move: 'touchmove',
        end: 'touchend'
    }
    : {
        start: 'mousedown',
        move: 'mousemove',
        end: 'mouseup'
    };
var SliderCaptcha = function (_a) {
    var _b, _c, _d, _e;
    var _f = _a.mode, outMode = _f === void 0 ? 'embed' : _f, _g = _a.limitErrorCount, limitErrorCount = _g === void 0 ? 0 : _g, outTipText = _a.tipText, outTipIcon = _a.tipIcon, outBgSize = _a.bgSize, outPuzzleSize = _a.puzzleSize, request = _a.request, _h = _a.autoRequest, autoRequest = _h === void 0 ? true : _h, onVerify = _a.onVerify, _j = _a.autoRefreshOnError, autoRefreshOnError = _j === void 0 ? true : _j, actionRef = _a.actionRef, _k = _a.showRefreshIcon, showRefreshIcon = _k === void 0 ? true : _k, jigsawContent = _a.jigsawContent, _l = _a.errorHoldDuration, errorHoldDuration = _l === void 0 ? 500 : _l, _m = _a.loadingDelay, loadingDelay = _m === void 0 ? 0 : _m, _o = _a.placement, placement = _o === void 0 ? 'top' : _o, loadingBoxProps = _a.loadingBoxProps, sliderButtonProps = _a.sliderButtonProps, className = _a.className, style = _a.style;
    var _p = useSafeState(), jigsawImgs = _p[0], setJigsawImgs = _p[1];
    var _q = useSafeState(Status.Default), status = _q[0], setStatus = _q[1];
    var latestStatus = useLatest(status); // 同步status值，提供给事件方法使用
    var loadingTimerRef = useRef(null); // 延迟加载状态定时器
    var hasLoadingDelay = typeof loadingDelay === 'number' && loadingDelay > 0;
    // dom ref
    var sliderButtonRef = useRef(null);
    var puzzleRef = useRef(null);
    var indicatorRef = useRef(null);
    var panelRef = useRef(null);
    // config
    var mode = useMemo(function () { return (outMode === 'float' || outMode === 'slider' ? outMode : 'embed'); }, [outMode]); // 模式
    var modeIsSlider = mode === 'slider';
    var tipText = useMemo(function () { return (__assign(__assign({}, defaultConfig.tipText), outTipText)); }, [outTipText]);
    var tipIcon = useMemo(function () { return (__assign(__assign({}, defaultConfig.tipIcon), outTipIcon)); }, [outTipIcon]);
    var bgSize = useMemo(function () { return (__assign(__assign({}, defaultConfig.bgSize), outBgSize)); }, [outBgSize]);
    var puzzleSize = useMemo(function () { return (__assign(__assign({}, defaultConfig.puzzleSize), outPuzzleSize)); }, [outPuzzleSize]);
    var placementPos = useMemo(function () { return (placement === 'bottom' ? 'top' : 'bottom'); }, [placement]);
    var currentTargetTypeRef = useRef(CurrentTargetType.Button); // 当前触发事件的节点，拼图或按钮
    var errorCountRef = useRef(0); // 连续错误次数
    var startInfoRef = useRef({ x: 0, y: 0, timestamp: 0 }); // 鼠标按下或触摸开始信息
    var trailRef = useRef([]); // 移动轨迹
    var isPressedRef = useRef(false); // 标识是否按下
    var sliderButtonWidthRef = useRef(SliderButtonWidth); // 滑块按钮宽度
    var floatTransitionTimerRef = useRef(null); // 触发式渐变过渡效果定时器
    var floatDelayShowTimerRef = useRef(null); // 触发式鼠标移入定时器
    var floatDelayHideTimerRef = useRef(null); // 触发式鼠标移出定时器
    var refreshTimerRef = useRef(null); // 自动刷新的定时器
    var isLimitErrors = latestStatus.current === Status.Error &&
        limitErrorCount > 0 &&
        errorCountRef.current >= limitErrorCount; // 是否超过限制错误次数
    var ratioRef = useRef(1); // 当滑块或拼图为触发事件的焦点时，两者的变换比例
    var maxDistanceRef = useRef({ button: 0, puzzle: 0 }); // 最大可移动距离
    // 更新最大可移动距离
    var updateMaxDistance = function () {
        maxDistanceRef.current.button = bgSize.width - sliderButtonWidthRef.current - SliderBorderWidth;
        maxDistanceRef.current.puzzle = bgSize.width - puzzleSize.width - puzzleSize.left;
    };
    // 获取背景图和拼图
    var getJigsawImages = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (modeIsSlider)
                        return [2 /*return*/];
                    if (!request) return [3 /*break*/, 2];
                    if (hasLoadingDelay) {
                        loadingTimerRef.current = setTimeout(function () {
                            setStatus(Status.Loading);
                        }, loadingDelay);
                    }
                    else {
                        setStatus(Status.Loading);
                    }
                    return [4 /*yield*/, request()];
                case 1:
                    result = _a.sent();
                    if (hasLoadingDelay) {
                        clearTimeout(loadingTimerRef.current);
                    }
                    setJigsawImgs(result);
                    setStatus(Status.Default);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    // 触发式下，显示面板
    var showPanel = function (delay) {
        if (delay === void 0) { delay = 300; }
        if (mode !== 'float' || latestStatus.current === Status.Success) {
            return;
        }
        clearTimeout(floatTransitionTimerRef.current);
        clearTimeout(floatDelayHideTimerRef.current);
        clearTimeout(floatDelayShowTimerRef.current);
        floatDelayShowTimerRef.current = setTimeout(function () {
            var _a;
            setStyle(panelRef.current, { display: 'block' });
            reflow(panelRef.current);
            setStyle(panelRef.current, (_a = {}, _a[placementPos] = '42px', _a.opacity = '1', _a));
        }, delay);
    };
    // 触发式下，隐藏面板
    var hidePanel = function (delay) {
        if (delay === void 0) { delay = 300; }
        if (mode !== 'float') {
            return;
        }
        clearTimeout(floatTransitionTimerRef.current);
        clearTimeout(floatDelayHideTimerRef.current);
        clearTimeout(floatDelayShowTimerRef.current);
        floatDelayHideTimerRef.current = setTimeout(function () {
            var _a;
            setStyle(panelRef.current, (_a = {}, _a[placementPos] = '22px', _a.opacity = '0', _a));
            floatTransitionTimerRef.current = setTimeout(function () {
                setStyle(panelRef.current, { display: 'none' });
            }, 300);
        }, delay);
    };
    // 重置状态和元素位置
    var reset = function () {
        isPressedRef.current = false;
        // isMovedRef.current = false;
        setStatus(Status.Default);
        setStyle(sliderButtonRef.current, { left: '0' });
        setStyle(indicatorRef.current, { width: '0' });
        setStyle(puzzleRef.current, { left: puzzleSize.left + 'px' });
    };
    // 刷新
    var refresh = function (resetErrorCount) {
        if (resetErrorCount === void 0) { resetErrorCount = false; }
        // 重置连续错误次数记录
        if (resetErrorCount) {
            errorCountRef.current = 0;
        }
        // 清除延迟调用刷新方法的定时器
        clearTimeout(refreshTimerRef.current);
        // 防止连续调用刷新方法，会触发多次请求的问题
        if (latestStatus.current === Status.Loading) {
            return;
        }
        reset();
        getJigsawImages();
    };
    // 点击滑块操作条，如果连续超过错误次数则刷新
    var handleClickControl = function () {
        if (isLimitErrors) {
            refresh(true);
        }
    };
    // 鼠标移入显示面板，如果支持touch事件不处理
    var handleMouseEnter = function () {
        if (isSupportTouch) {
            return;
        }
        showPanel();
    };
    // 鼠标移出隐藏面板，如果支持touch事件不处理
    var handleMouseLeave = function () {
        if (isSupportTouch) {
            return;
        }
        hidePanel();
    };
    // 点击刷新图标
    var handleClickRefreshIcon = function () {
        if (status !== Status.Verify && !isLimitErrors) {
            refresh();
        }
    };
    // 鼠标按下或触摸开始
    var touchstart = function (e) {
        if (latestStatus.current !== Status.Default) {
            return;
        }
        e.preventDefault(); // 防止移动端按下后会选择文本或图片
        var target = e.currentTarget; // 用于判断当前触发事件的节点
        if (target && sliderButtonRef.current && (modeIsSlider || puzzleRef.current)) {
            var _a = getClient(e), clientX = _a.clientX, clientY = _a.clientY;
            startInfoRef.current = {
                x: clientX,
                y: clientY,
                timestamp: new Date().getTime()
            };
            trailRef.current = [[startInfoRef.current.x, startInfoRef.current.y]];
            sliderButtonWidthRef.current = sliderButtonRef.current.clientWidth;
            updateMaxDistance();
            currentTargetTypeRef.current = target.getAttribute('data-id');
            // 最大可移动区间值比例
            ratioRef.current = maxDistanceRef.current.puzzle / maxDistanceRef.current.button;
            if (currentTargetTypeRef.current === CurrentTargetType.Puzzle) {
                ratioRef.current = 1 / ratioRef.current;
            }
            // 处理移动端-触发式兼容
            if (isSupportTouch) {
                showPanel(0);
            }
            isPressedRef.current = true;
            document.addEventListener(events.move, touchmove);
            document.addEventListener(events.end, touchend);
            document.addEventListener('touchcancel', touchend);
        }
    };
    // 鼠标移动 或 触摸移动
    var touchmove = function (e) {
        if (!isPressedRef.current) {
            return;
        }
        e.preventDefault();
        var _a = getClient(e), clientX = _a.clientX, clientY = _a.clientY;
        var diffX = clientX - startInfoRef.current.x; // 移动距离
        trailRef.current.push([clientX, clientY]); // 记录移动轨迹
        if (latestStatus.current !== Status.Moving && diffX > 0) {
            setStatus(Status.Moving);
        }
        var puzzleLeft = diffX; // 拼图左偏移值
        var sliderButtonLeft = diffX; // 滑块按钮左偏移值
        if (currentTargetTypeRef.current === CurrentTargetType.Puzzle) {
            diffX = Math.max(0, Math.min(diffX, maxDistanceRef.current.puzzle));
            puzzleLeft = diffX + puzzleSize.left;
            sliderButtonLeft = diffX * ratioRef.current;
        }
        else {
            diffX = Math.max(0, Math.min(diffX, maxDistanceRef.current.button));
            sliderButtonLeft = diffX;
            puzzleLeft = diffX * ratioRef.current + puzzleSize.left;
        }
        setStyle(sliderButtonRef.current, { left: sliderButtonLeft + 'px' });
        setStyle(indicatorRef.current, {
            width: sliderButtonLeft + sliderButtonWidthRef.current + SliderBorderWidth + 'px'
        });
        setStyle(puzzleRef.current, { left: puzzleLeft + 'px' });
    };
    // 鼠标弹起 或 停止触摸
    var touchend = function (e) {
        document.removeEventListener(events.move, touchmove);
        document.removeEventListener(events.end, touchend);
        document.removeEventListener('touchcancel', touchend);
        if (!isPressedRef.current) {
            return;
        }
        if (latestStatus.current !== Status.Moving) {
            isPressedRef.current = false;
            // 如果是移动端事件，并且是触发式，隐藏浮层
            if (isSupportTouch) {
                hidePanel();
            }
            return;
        }
        if (onVerify) {
            isPressedRef.current = false;
            setStatus(Status.Verify);
            var endTimestamp = new Date().getTime();
            var _a = getClient(e), clientX = _a.clientX, clientY = _a.clientY;
            var diffY = clientY - startInfoRef.current.y;
            var diffX = clientX - startInfoRef.current.x; // 拼图移动距离
            var sliderOffsetX = diffX; // 滑块偏移值
            if (currentTargetTypeRef.current === CurrentTargetType.Puzzle) {
                diffX = Math.max(0, Math.min(diffX, maxDistanceRef.current.puzzle));
                sliderOffsetX = diffX * ratioRef.current;
            }
            else {
                diffX = Math.max(0, Math.min(diffX, maxDistanceRef.current.button));
                sliderOffsetX = diffX;
                diffX *= ratioRef.current;
            }
            onVerify({
                x: diffX,
                y: diffY,
                sliderOffsetX: sliderOffsetX,
                duration: endTimestamp - startInfoRef.current.timestamp,
                trail: trailRef.current,
                targetType: currentTargetTypeRef.current,
                errorCount: errorCountRef.current
            })
                .then(function () {
                errorCountRef.current = 0;
                setStatus(Status.Success);
                hidePanel();
            })
                .catch(function () {
                errorCountRef.current += 1;
                setStatus(Status.Error);
                if (isSupportTouch) {
                    hidePanel();
                }
                if ((limitErrorCount <= 0 || errorCountRef.current < limitErrorCount) &&
                    autoRefreshOnError) {
                    refreshTimerRef.current = setTimeout(function () {
                        refresh();
                    }, errorHoldDuration);
                }
            });
        }
        else {
            reset();
        }
    };
    useEffect(function () {
        if (autoRequest) {
            getJigsawImages();
        }
        var sliderButtonTarget = sliderButtonRef.current;
        var puzzleTarget = puzzleRef.current;
        if (isBrowser && sliderButtonTarget) {
            sliderButtonTarget.addEventListener(events.start, touchstart);
            puzzleTarget && puzzleTarget.addEventListener(events.start, touchstart);
            return function () {
                sliderButtonTarget.removeEventListener(events.start, touchstart);
                puzzleTarget && puzzleTarget.removeEventListener(events.start, touchstart);
                document.removeEventListener(events.move, touchmove);
                document.removeEventListener(events.end, touchend);
                document.removeEventListener('touchcancel', touchend);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var loading = status === Status.Loading; // 加载中
    var isStop = status === Status.Verify || status === Status.Error || status === Status.Success; // 是否停止滑动
    // 当前提示文本
    var currentTipText = useMemo(function () {
        if (status === Status.Default) {
            return tipText.default;
        }
        if (status === Status.Loading) {
            return tipText.loading;
        }
        if (status === Status.Moving) {
            return tipText.moving;
        }
        if (status === Status.Verify) {
            return tipText.verifying;
        }
        if (isLimitErrors) {
            return tipText.errors;
        }
        if (status === Status.Error) {
            return tipText.error;
        }
        if (status === Status.Success) {
            return tipText.success;
        }
        return null;
    }, [status, tipText, isLimitErrors]);
    // 当前提示图标
    var currentTipIcon = useMemo(function () {
        if (status === Status.Success) {
            return tipIcon.success;
        }
        if (status === Status.Error) {
            return tipIcon.error;
        }
        if (status === Status.Verify) {
            return tipIcon.loading;
        }
        return tipIcon.default;
    }, [status, tipIcon]);
    // 提供给外部
    React.useImperativeHandle(actionRef, function () { return ({
        refresh: refresh,
        get status() {
            return latestStatus.current;
        }
    }); });
    return (React.createElement("div", { className: classnames(prefixCls, className, "".concat(prefixCls, "-").concat(mode), (_b = {},
            _b["".concat(prefixCls, "-").concat(mode, "-").concat(placement)] = mode === 'float',
            _b)), style: __assign({ width: bgSize.width }, style), onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave },
        !modeIsSlider && (React.createElement("div", { className: "".concat(prefixCls, "-panel"), ref: panelRef },
            React.createElement("div", { className: "".concat(prefixCls, "-panel-inner"), style: { height: bgSize.height } },
                React.createElement("div", { className: classnames(jigsawPrefixCls, (_c = {}, _c["".concat(jigsawPrefixCls, "-stop")] = isStop, _c)), style: __assign(__assign({}, bgSize), (loading || !(jigsawImgs === null || jigsawImgs === void 0 ? void 0 : jigsawImgs.bgUrl) ? { display: 'none' } : {})) },
                    React.createElement("img", { className: "".concat(jigsawPrefixCls, "-bg"), style: bgSize, src: jigsawImgs === null || jigsawImgs === void 0 ? void 0 : jigsawImgs.bgUrl, alt: "" }),
                    React.createElement("img", { className: "".concat(jigsawPrefixCls, "-puzzle"), style: puzzleSize, src: jigsawImgs === null || jigsawImgs === void 0 ? void 0 : jigsawImgs.puzzleUrl, alt: "", "data-id": CurrentTargetType.Puzzle, ref: puzzleRef }),
                    showRefreshIcon && status !== Status.Success && tipIcon.refresh && (React.createElement("div", { className: classnames("".concat(jigsawPrefixCls, "-refresh"), (_d = {},
                            _d["".concat(jigsawPrefixCls, "-refresh-disabled")] = status === Status.Verify || isLimitErrors,
                            _d)), onClick: handleClickRefreshIcon }, tipIcon.refresh)),
                    jigsawContent),
                React.createElement(LoadingBox, __assign({}, loadingBoxProps, { style: __assign(__assign(__assign({}, loadingBoxProps === null || loadingBoxProps === void 0 ? void 0 : loadingBoxProps.style), bgSize), (loading ? {} : { display: 'none' })) }))))),
        React.createElement("div", { className: classnames(controlPrefixCls, (_e = {},
                _e["".concat(controlPrefixCls, "-loading")] = loading,
                _e["".concat(controlPrefixCls, "-moving")] = status === Status.Moving,
                _e["".concat(controlPrefixCls, "-verify")] = status === Status.Verify,
                _e["".concat(controlPrefixCls, "-success")] = status === Status.Success,
                _e["".concat(controlPrefixCls, "-error")] = status === Status.Error,
                _e["".concat(controlPrefixCls, "-errors")] = isLimitErrors,
                _e)), onClick: handleClickControl },
            React.createElement("div", { className: classnames("".concat(controlPrefixCls, "-indicator")), ref: indicatorRef }),
            React.createElement(SliderButton, __assign({}, sliderButtonProps, { className: classnames("".concat(controlPrefixCls, "-button"), sliderButtonProps === null || sliderButtonProps === void 0 ? void 0 : sliderButtonProps.className), disabled: loading, active: status === Status.Moving, verify: status === Status.Verify, success: status === Status.Success, error: status === Status.Error, "data-id": CurrentTargetType.Button, mobile: isSupportTouch, ref: sliderButtonRef }), currentTipIcon),
            currentTipText && (React.createElement("div", { className: classnames("".concat(controlPrefixCls, "-tips")) }, currentTipText)))));
};

export { CurrentTargetType, Status, SliderCaptcha as default };
